import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import { StoreContext } from "redux-react-hook";
import { createBrowserHistory } from "history";
import { Amplify } from "aws-amplify";
import { Provider } from "react-redux";
import { useEffect } from "react";
import { configureStore } from "store/store";
import logging from "config/logging";
import AuthEventListener from "./AuthEventListener";
import Routes from "./Routes";
import { CssBaseline } from "@mui/material";

const awsconfigOverride = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USERPOOL_ID,
      userPoolClientId: import.meta.env.VITE_USERPOOL_WEBCLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_OAUTH_DOMAIN,
          scopes: ["email", "openid"],
          redirectSignIn: [`${window.location.origin}/`],
          redirectSignOut: [`${window.location.origin}/`],
          responseType: "code" as const
        }
      }
    }
  }
};
Amplify.configure(awsconfigOverride);

const history = createBrowserHistory();
const store = configureStore(history);
// noinspection JSIgnoredPromiseFromCall
AuthEventListener.init(store);

const App: React.FC = () => {
  useEffect(() => {
    logging.info("Loading application.");
  }, []);
  return (
    <div>
      <CssBaseline />
      <Provider store={store}>
        <StoreContext.Provider value={store}>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </StoreContext.Provider>
      </Provider>
    </div>
  );
};

export default App;
